import React, { useState, useContext, useRef, useEffect } from "react";
import { Formik, Form, FieldArray } from "formik";
import { getImages } from "../Const";
import { LeadsContext } from "../Context/LeadsContext";
import Fancybox from "../Front/Fancybox";

const MAX_FILES = 30;
const MAX_FILE_SIZE_MB = 5; // 5 MB max for images

const DropZoneBoxImage = ({ leadId, showUpload, onChange, uploadedImages, documentData, leadPhotos }) => {
    const { uploadDocument } = useContext(LeadsContext);

    const [imagePreviews, setImagePreviews] = useState([]);
    const [selectedImages, setSelectedImages] = useState([]); // ✅ Track selected
    const [selectAll, setSelectAll] = useState(false); // ✅ Track select all
    const formikRef = useRef(null);

    // --- Image Upload Handlers ---

    const handleImageChange = (event, setFieldValue) => {
        const files = Array.from(event.target.files);
  
        const newImages = files.map(file => URL.createObjectURL(file));
        setSelectedImages(prevImages => [...prevImages, ...newImages]);
        //setFieldValue('photos', event.target.files);
  
        uploadFiles(event.target.files);
    };
  
    const handleDrop = (event, setFieldValue) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        const newImages = files.map(file => URL.createObjectURL(file));
        setSelectedImages(prevImages => [...prevImages, ...newImages]);
        //setFieldValue('photos', event.dataTransfer.files);
  
        uploadFiles(event.dataTransfer.files);
    };
  
    const uploadFiles = (files) => {
        Array.from(files).map((v, i) => {
            uploadFile(v);
        });
    }
  
    const uploadFile = (file) => {
  
        const fileSizeMB = file.size / (1024 * 1024);
  
        console.log(file);
  
        if (file && file.type.startsWith("image/") && fileSizeMB <= MAX_FILE_SIZE_MB) {
  
            const formData = new FormData();
            formData.append('file', file);
            formData.append('folder', 'appraisals/lead'+leadId+'/');
            formData.append('fileName', file.name);
            //formData.append('base_url',true);
  
            const upload = uploadDocument(formData);
            upload.then((data) => {
                if (data.url && data.data && data.data.key) {
  
                    formikRef.current.setFieldValue("photos", [...formikRef.current.values.photos, data.url]);
  
                    console.log(formikRef.current.values);
  
                    setImagePreviews((prev) => [...prev, { name: file.name, url: data.url }]);
  
                } else if (data.error) alert(data.error);
            });
        }
  
    }

    const handleImageDragOver = (e) => {
        e.preventDefault();
    };

    // ✅ Remove all selected images
    const handleDeleteSelected = () => {
        const updated = imagePreviews.filter(
            (_, index) => !selectedImages.includes(index)
        );
        formikRef.current.setFieldValue(
            "photos",
            updated.map((img) => img.url)
        );
        setImagePreviews(updated);
        setSelectedImages([]);
        setSelectAll(false);
        if (onChange) onChange(updated);
    };

    useEffect(() => {
        if(documentData) {
            const docs = documentData.filter((v) => v.headers['content-type'].includes('image')).map((v) => ({ name: v.name, url: v.url }));
            formikRef.current.setFieldValue("photos", docs.map((d) => d.url));
            setImagePreviews(docs);
            if (onChange) onChange(docs);
        }
    }, [leadId,documentData]);

    return (
        <Formik
            initialValues={{ photos: [] }}
            innerRef={formikRef}
            onSubmit={(values) => console.log(values)}
        >
            {({ setFieldValue, values }) => (
                <Form>
                    {imagePreviews.length > 0 && (
                        <div className="d-block mt-4">
                            <div className="adr-value font-1em text-uppercase mb-2">Photos</div>
                            <div className="row g-2 photo-lists">
                                <Fancybox
                                    options={{
                                        Carousel: {
                                            infinite: false,
                                        },
                                    }}
                                >
                                    {imagePreviews && imagePreviews.map((item, index) =>                                        
                                        <div className="col-6" key={index}>
                                            <div className="photo-list-image position-relative">
                                            <a key={index} data-fancybox="gallery" href={item.url} target="_blank">
                                                <img src={item.url} alt={item.name} />
                                            </a>
                                            </div>
                                        </div>
                                    )}
                                    {imagePreviews.length > 1 ? <div className='vi-count'>+{imagePreviews.length}</div> : ""}
                                </Fancybox>
                            </div>
                            <div className="d-flex align-items-center mt-3 justify-content-between">
                                <div className="custom-checkbox begin-checkbox dzb-checkbox me-5">
                                    <input
                                        type="checkbox"
                                        id="SelectAll"
                                        checked={selectAll}
                                        onChange={(e) => {
                                            setSelectAll(e.target.checked);
                                            if (e.target.checked) {
                                                setSelectedImages(
                                                    imagePreviews.map((_, i) => i)
                                                );
                                            } else {
                                                setSelectedImages([]);
                                            }
                                        }}
                                    />
                                    <label htmlFor="SelectAll">Select All</label>
                                </div>

                                <button
                                    type="button"
                                    className="btn-transparent-btn"
                                    onClick={handleDeleteSelected}
                                    disabled={selectedImages.length === 0}
                                >
                                    <img src={getImages("delete-icon1.svg")} alt="Delete" />
                                </button>
                            </div>
                        </div>
                    )}
                    {leadPhotos?.length > 0 && (
                        <div className="d-block mt-4">
                            <div className="adr-value font-1em text-uppercase mb-2">Photos</div>
                            <div className="row g-2 photo-lists">
                            <Fancybox
                                options={{
                                    Carousel: {
                                        infinite: false,
                                    },
                                }}
                            >
                                {leadPhotos && leadPhotos.map((item, index) =>
                                    <div className="col-6" key={index}>
                                        <div className="photo-list-image position-relative">
                                            <a  data-fancybox="gallery" href={item} target="_blank">
                                                <img src={item}  />
                                            </a>
                                        </div>
                                    </div>
                                )}
                                {leadPhotos.length > 1 ? <div className='vi-count'>+{leadPhotos.length}</div> : ""}
                            </Fancybox>
                            </div>
                        </div>
                    )}
                    

                    <FieldArray type="hidden" name="photos" value={values.photos} />

                    {/* Upload Section */}
                    <div className="d-block mt-4">
                        <div
                            className="drop-zone-box adq-zone-box p-4"
                            onDrop={(e) => handleDrop(e, setFieldValue)}
                            onDragOver={handleImageDragOver}
                        >
                            <div className="drop-zone text-uppercase text-center">
                                <div className="mb-3 text-center">
                                    <img
                                        style={{ maxWidth: "48px" }}
                                        src={getImages("icon-upload.png")}
                                        alt="upload"
                                    />
                                </div>
                            </div>
                            <div className="my-3 text-dblue xs-title text-uppercase text-center font-1em">
                                Upload Images
                            </div>
                            <div className="text-center">
                                <div className="blue-btn adq-upload-btn text-uppercase position-relative fw-700 p-0">
                                    <label htmlFor="imageInput">
                                        <span>Browse</span>
                                    </label>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        multiple
                                        onChange={(e) => handleImageChange(e, setFieldValue)}
                                        id="imageInput"
                                        hidden
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default DropZoneBoxImage;
